module.exports = __webpack_public_path__ + "static/img/msg.fc1cb09.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/msg.png
// module id = QqtN
// module chunks = 1